import { ref, computed, onMounted, onUnmounted } from "vue";

export function useBreakpoint() {
  const width = ref(window.innerWidth);

  const checkSize = () => {
    width.value = window.innerWidth;
  };

  onMounted(() => {
    checkSize();
    window.addEventListener("resize", checkSize);
  });

  onUnmounted(() => {
    window.removeEventListener("resize", checkSize);
  });

  const isMobile = computed(() => width.value < 768);
  const isTablet = computed(() => width.value >= 768 && width.value < 1024);
  const isDesktop = computed(() => width.value >= 1024);

  const currentSize = computed(() => {
    if ( isMobile.value ) {
      return 'mobile'
    } else if ( isTablet.value ) {
      return 'tablet'
    } else {
      return 'desktop'
    }
  });

  return {
    width,
    isMobile,
    isTablet,
    isDesktop,
    currentSize,
  };
}
